

export interface PatentOfficeImageItemResponse {
    type: string
    height: number;
    width: number;
    url: string;
}

export interface PatentOfficeImagesResponse {
    OFFICIAL_IMAGE: Record<string, PatentOfficeImageItemResponse>;
    OFFICIAL_IMAGE_240: Record<string, PatentOfficeImageItemResponse>;
}
export interface PatentImageApi {
    /**
     * 获取专利图像
     */
    getPatentOfficeImage(payload: {patentId: string}): Promise<PatentOfficeImagesResponse>;
}

export const PatentImageApi = Symbol.for('PatentImageApi');
